import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Input from '@welldev-group/rcl-input';
import Button from '@welldev-group/rcl-button';
import { I18nText } from '@welldev-group/react-comp-lib';
import WorkspaceCard from '../WorkspaceCard';

const WorkspaceTableEditRow = ({
  affiliateId,
  workspace,
  toggleEditable,
  index,
  updateWorkspace,
  fetchWorkspaces,
}) => {
  const touched = true;
  const [error, setError] = useState({});
  const [workspaceName, setWorkspaceName] = useState(workspace.name);

  const onClick = () => {
    updateWorkspace(workspace.id, workspaceName, affiliateId)
      .then(response => {
        if (response.error === null) {
          fetchWorkspaces();
        }
      })
      .catch(({ response }) => {
        if (response.status === 422) {
          setError(response.data.error);
        }
      });
  };
  return (
    <WorkspaceCard>
      <div className="col-lg-4 col-md-12 col-12 workspace-table__row-content-name-field">
        <Input
          value={workspaceName}
          onChange={value => setWorkspaceName(value)}
          placeholder={I18n.t('components.workspace.placeholder.name')}
          error={error.name}
          touched={touched}
        />
      </div>
      <div className="col-lg-8 col-md-12 col-12 align-self-center workspace-table__row-content--actions-field">
        <div className="workspace-table__actions-field-save">
          <Button
            label={<I18nText id="workspace.edit.button_label.save" />}
            onClick={() => onClick()}
            version="v2"
            size="small"
            type="primary"
          />
        </div>
        <div className="workspace-table__actions-field-cancel">
          <Button
            label={<I18nText id="workspace.button_label.cancel" />}
            onClick={() => toggleEditable(index, false)}
            version="v2"
            size="small"
            type="primary"
          />
        </div>
      </div>
    </WorkspaceCard>
  );
};

WorkspaceTableEditRow.propTypes = {
  workspace: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    identifier: PropTypes.string.isRequired,
  }).isRequired,
  affiliateId: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  updateWorkspace: PropTypes.func.isRequired,
  toggleEditable: PropTypes.func.isRequired,
  fetchWorkspaces: PropTypes.func.isRequired,
};

export default WorkspaceTableEditRow;
